export const ErrorDisplay = ({ error }) => (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4">
      <div className="bg-red-50 border border-red-100 rounded-xl p-4 sm:p-8 shadow-lg max-w-md w-full">
        <h3 className="text-red-800 font-semibold text-base sm:text-lg mb-2 sm:mb-3">Error Loading Game</h3>
        <p className="text-red-600 text-sm sm:text-base">{error}</p>
      </div>
    </div>
  );